export const players = [
    {
        id: 1,
        imgSrc: 'images/1.jpg',
        answer: 'Morten Gamst Pedersen',
        question: 'Who am I?'
    },
    {
        id: 2,
        imgSrc: 'images/2.jpg',
        answer: 'Jordan Pickford',
        question: 'Who am I?'
    },   
    {
        id: 3,
        imgSrc: 'images/3.jpg',
        answer: 'Elliot Anderson',
        question: 'Who am I?'
    },
    {
        id: 4,
        imgSrc: 'images/4.jpg',
        answer: 'David Platt',
        question: 'Who am I?'
    },
    {
        id: 5,
        imgSrc: 'images/5.jpg',
        answer: 'Serge Gnabry',
        question: 'Who am I?'
    },
    {
        id: 6,
        imgSrc: 'images/6.jpg',
        answer: 'Matej Vydra',
        question: 'Who am I?'
    },
    {
        id: 7,
        imgSrc: 'images/7.jpg',
        answer: 'Alexander Buttner',
        question: 'Who am I?'
    },
]